import { Component } from '@angular/core';

import { ColorType } from '@camelot/styles';
import { TranslatePipe } from '@camelot/translation';
import { BadgeComponent } from '@camelot/ui';

import { CamTranslationCore } from '../../../../../translation.service';
import { RowType } from '../../../services/dto/row-type';
import { AbstractCellComponent } from '../../abstract';

export const rowTypeLabel = (rowType: number) => `core.row-types.${RowType[rowType]?.toLowerCase() ?? 'unknown'}`;

@Component({
  host: { 'data-cid': 'grid-row-type-cell' },
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '',
  imports: [BadgeComponent, TranslatePipe],
  template: `
    @if (this.value !== null && this.value !== undefined) {
      <div class="flex-start align-center" style="height: 100%">
        <cam-badge class="d-flex" [type]="this.getType()" [value]="this.getTranslate() | translate"></cam-badge>
      </div>
    }
  `,
})
export class GridRowTypeCellComponent extends AbstractCellComponent<unknown, number> {
  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  public getType(): ColorType {
    switch (this.value) {
      case RowType.Chapter:
        return 'secondary';
      case RowType.Item:
        return 'default';
      case RowType.Comment:
        return 'purple';
      default:
        return 'default';
    }
  }

  public getTranslate() {
    return rowTypeLabel(this.value ?? RowType.Unknown);
  }
}
